import { render, staticRenderFns } from "./VStatisticsCrad.vue?vue&type=template&id=1943435a"
import script from "./VStatisticsCrad.vue?vue&type=script&lang=js"
export * from "./VStatisticsCrad.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports